export const messageTypes = {
  E0531: {
    code: "E0531",
    msg: "No App keys exists for this app!",
  },
  E05422: {
    code: "E05422",
    msg: "At least one platform should be selected",
  },
};
